import type { CastItem } from "@/types/aggregate-items";
import { logItemInteraction, logUserInteraction } from "@/utils/logger";

export interface Input {
  item: CastItem;
}

export default class CastDiscoverItemCard extends Marko.Component<Input> {
  handleItemClick() {
    const { item } = this.input;

    // Log the item click interaction
    logItemInteraction("click", item.listingId, "discover_item");

    // Also log additional details as a separate event
    logUserInteraction("click", "discover_item_card", {
      itemId: item.listingId,
      influencerName: item.influencer.name,
      price: item.displayPrice,
      url: item.url,
    });
  }
}
